jQuery(document).ready(function() {
  var $ = jQuery;
  var isMobile = true;
  $('.js-tabgroup').each(function() {
    var $group = $(this);
    var $tabs = $('> ul a[data-tab]', this);
    var name = $group.closest('li').attr('id');
    $tabs.on('click', function(e) {
      e.preventDefault();
      $group.children('.js-tabcontent').removeClass('tabcontent-selected');
      $('> ul a[data-tab]', $group).removeClass('tab-selected');
      var choice = $(this).addClass('tab-selected').attr('data-tab');
      var $content = $(choice).addClass('tabcontent-selected');
      window._setCookie('choice-' + name, choice);
    });
    var cookieVal = window._getCookie('choice-' + name);
    // Get cookie tab, or first tab.
    var $cookieTab = $tabs.filter('[data-tab="' + cookieVal + '"]');
    (($cookieTab.length && $cookieTab) || $tabs.first()).trigger('click');
  });

  var $dropdowns = $('.modern-menu__menu > li.menu-item-has-children > a');
  $dropdowns.on('click', function(e) {
    e.preventDefault();
    var $parent = $(this).parent();
    var $body = $('body');
    if($parent.hasClass('open')) {
      $parent.removeClass('open');
      $body.removeClass('modern-menu-open');
    } else {
      $('.modern-menu__menu > li').removeClass('open');
      $parent.addClass('open');
      $body.addClass('modern-menu-open');
    }
  });
  $dropdowns.each(function() {
    var $this = $(this);
    if($this.attr('href') != '#') {
      var $menu = $this.closest('li');
      var submenus = [];
      if($menu.find('.js-tabgroup')) {
        $menu.find('.js-tabcontent').each(function() {
          var $item = $('.sub-menu', this).first();
          if($item.length) {
            submenus.push($item);
          }
        });
        //  
      } else {
        submenus.push($menu.find('sub-menu'));
      }
      submenus.forEach(function($sub) {
        $this.clone().addClass('mobile-nav__extra-dropdown').html('View ' + $this.html() + '&hellip;').insertBefore($sub);
      });
    }
  });

  $('body').on('click', function(e) {
    var $this = $(e.target);
    if(!$this.closest('.main-header').length) {
      $('.modern-menu__menu .open').removeClass('open');
      $('body').removeClass('modern-menu-open').removeClass('mobile-nav-open');
      $('.mobile-nav__check').prop('checked', false);
    }
  });

  $('.mobile-nav__check').on('click', function() {
    var $this = $(this);
    $('body').toggleClass('mobile-nav-open', $this.is(':checked'));
  });

  /*
  var handleBreakpointChange = function(e) {
    var tablet = window.currentBreakpoint.includes('tabletlandscape');
    if(tablet && isMobile) {
      isMobile = false;
    } else if(!tablet && !isMobile) {
      isMobile = true;
    }
  };
  $(window).on('breakpoint-tablet breakpoint-tabletlandscape', handleBreakpointChange);
  handleBreakpointChange();
  */

  /*if($('#wpfront-notification-bar-spacer').length) {
    var $header = $('.main-header');
    var top = $header.offset().top;
    $header.css('top', top);
  }*/
});
